import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../../../../common/global/helpers';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import useMount from '../../../../../../common/hooks/useMount';
import Carousel from '../../../../../../common/widgets/Carousel';
import { config } from '../../../../config';
import { BenefitBucksCompleteWallet } from '../../../../models/BenefitBucks';
import { resources } from '../../../../resources/resources';
import { benefitBucksService } from '../../../../services/benefitBucks';
import BenefitBucksWide from '../../../Common/Marketing/BenefitBucksWide';

export default function BenefitBucksWallet() {
  const { t: translate } = useTranslation();
  const { isMobile } = useBreakpoints();
  const [wallet, setWallet] = useState<BenefitBucksCompleteWallet | null>();

  const loadWallet = async (abortController?: AbortController) => {
    const result = await benefitBucksService.getWallet({
      signal: abortController?.signal,
    });
    if (!result.hasErrors) {
      setWallet(result.data);
    } else if (!abortController?.signal.aborted) {
      setWallet(null);
    }
  };

  useMount(abortController => loadWallet(abortController));

  const walletDetails = [
    { label: resources.benefitBucksWallet.balance, format: wallet?.balance },
    {
      label: resources.benefitBucksWallet.pendingBalance,
      format: wallet?.pendingBalance,
    },
    {
      label: resources.benefitBucksWallet.spentAmount,
      format: wallet?.spentAmount,
    },
  ];

  return (
    <>
      {/* Marketing cards */}
      <div className="mkt-cards benefit-bucks-mkt">
        <BenefitBucksWide />
      </div>
      {/* Available Benefit Bucks */}
      {!isMobile ? (
        <div className="row bb-cards equal-heights-content">
          {walletDetails.map(item => (
            <div key={item.label} className="col col-4 col-xs-12">
              <div className="bb-card">
                <div className="bb-card-label">{translate(item.label)}</div>
                <div className="bb-card-balance">
                  {formatPrice(item.format)}
                  <sup>{config.currency}</sup>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="edn-carousel no-dots-mobile carousel-gap-xxs-10">
          <Carousel
            loading={false}
            arrows={false}
            slidesToShow={1.5}
            slidesToScroll={1}
            infinite={false}
          >
            {walletDetails.map(item => (
              <div key={item.label} className="col col-4 col-xs-12">
                <div className="bb-card">
                  <div className="bb-card-label">{translate(item.label)}</div>
                  <div className="bb-card-balance">
                    {formatPrice(item.format)}
                    <sup>{config.currency}</sup>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </>
  );
}
